import { render } from "./top-products.vue?vue&type=template&id=2a178a9a&scoped=true"
import script from "./top-products.vue?vue&type=script&lang=js"
export * from "./top-products.vue?vue&type=script&lang=js"

import "./top-products.vue?vue&type=style&index=0&id=2a178a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a178a9a"]])

export default __exports__